<template>
  <div class="main-box">
    <a-card
      style="width:100%;"
      :tabList="tabListNoTitle"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-show="noTitleKey === 'RoleManagement'">
        <a-table :columns="columns" :dataSource="data" rowKey="id" :loading="loading" :pagination="pagination">
          <div slot="status" slot-scope="text, record">
            <a-tag color="green" v-if="record.status === 1">开启</a-tag>
            <a-tag color="red" v-else-if="record.status === 0">禁用</a-tag>
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="PermissionSettingsVisible(record)">权限设置</a-button>
            <a-button @click="editSettingsVisible(record)" class="edit-setting">编辑</a-button>
            <a-button type="danger" @click="showDeleteConfirm(record)">删除</a-button>
          </div>
        </a-table>
      </div>
      <div v-show="noTitleKey === 'AddManagement'">
        <set-management :record="record" :type="type" ref="AddManagement" @ok="handleRefresh" />
      </div>
      <!-- 权限设置modal -->
      <a-modal title="编辑权限设置" v-model="PermissionSettings" @ok="settingOk">
        <a-tree
          checkable
          @check="onCheck"
          :defaultCheckedKeys="keySeleList"
          v-model="keySeleList"
          :treeData="treeData"
          defaultExpandAll
        />
        <!-- 默认展开所有权限节点 -->
      </a-modal>
      <!-- 权限编辑modal -->
      <a-modal title="编辑角色" v-model="settingEditVisible" @ok="settingEditOk" :maskClosable="false" :confirmLoading="confirmLoading">
        <!-- 角色管理>编辑&添加角色 -->
        <set-management :record="record" :type="type" ref="AddManagement" @ok="handleRefresh" @cancel="handleCancel"/>
      </a-modal>
      <!-- <div class="addPersetting">
        <a-button type="primary" @click="addPermissionSettingsVisible">新增权限设置</a-button>
      </div> -->
    </a-card>
  </div>
</template>
<script>
import setManagement from './modules/setManagement'
import { getRoleList, delRole, adminArticle, updateRoleAuthorize } from '@/api/manage'

// 角色配置表格数据
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: '5%',
    key: 'id'
  },
  {
    title: '角色名称',
    dataIndex: 'name',
    width: '8%',
    key: 'name'
  },
  {
    title: '角色描述',
    dataIndex: 'remark',
    width: '30%',
    key: 'remark'
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: '10%',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    key: 'action',
    width: '20%',
    scopedSlots: { customRender: 'action' }
  }
]

const data = []

export default {
  components: {
    setManagement
  },
  data () {
    return {
      tabListNoTitle: [
        {
          key: 'RoleManagement',
          tab: '角色管理'
        },
        {
          key: 'AddManagement',
          tab: '添加角色'
        }
      ],
      noTitleKey: 'RoleManagement',
      // 角色表格
      data,
      columns,
      // 权限添加modal
      PermissionSettings: false,
      // 权限设置
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      title: '',
      checkUrl: '',
      arrParentId: [],
      // 权限编辑modal
      settingEditVisible: false,
      loading: false,
      confirmLoading: false,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      record: {},
      type: 1,
      keySeleList: []
    }
  },
  // 权限设置数据改变触发
  mounted () {
    this.handleInitList()
  },
  methods: {
    handleRefresh () {
      this.noTitleKey = 'RoleManagement'
      this.settingEditVisible = false
      this.confirmLoading = false
      this.handleInitList()
    },
    // 管理员角色授权
    PermissionSettingsVisible (record) {
      this.record = record
      this.adminArticle(record.id)
    },
    handleInitList () {
      this.loading = true
      return getRoleList({
        status: 2
      })
        .then(res => {
          this.data = res.result
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取用户管理权限列表
    adminArticle (id) {
      return adminArticle({ 'role_id': id })
        .then((res) => {
          const keySeleList = []
          this.treeData = res.result
          res.result.forEach((item, index) => {
            item.is_check === 1 ? keySeleList.push('0-' + index) : ''
            if (item.children) {
              item.children.forEach((i, ide) => {
                i.is_check === 1 ? keySeleList.push('0-' + index + '-' + ide) : ''
                if (i.children) {
                  i.children.forEach((value, dex) => {
                    value.is_check === 1 ? keySeleList.push('0-' + index + '-' + ide + '-' + dex) : ''
                  })
                }
              })
            }
          })
          console.log(keySeleList)
          this.keySeleList = keySeleList
          this.PermissionSettings = true
        })
    },
    onTabChange (key, type) {
      console.log(key, type)
      this[type] = key
      this.type = 1
      this.record = {}
    },
    settingOk (e) {
      var arrParentIdList = this.arrParentId.join(',')
      return updateRoleAuthorize({
        adminRoleId: this.record.id,
        adminAccess: arrParentIdList
      }).then((res) => {
        this.$message.success(res.msg)
        this.PermissionSettings = false
        this.handleInitList()
      }).catch((res) => {
        this.$message.error(res.msg)
        this.PermissionSettings = false
      }).finally((res) => {
      })
    },
    // 权限设置树状结构
    onCheck (checkedKeys, event, bool, checkedNodes, node) {
      var checkTitle = event.checkedNodesPositions
      var arrParentId = []
      checkTitle.forEach((item) => {
        arrParentId.push(item.node.data.props.id)
      })
      this.arrParentId = arrParentId
    },
    editSettingsVisible (record) {
      this.settingEditVisible = true
      this.record = record
      this.type = 2
      this.$nextTick(() => {
        this.$refs.AddManagement.show()
      })
    },
    settingEditOk (e) {
      // console.log(e)
      this.confirmLoading = true
      this.$refs.AddManagement.addSettingRoles(e)
    },
    // 删除按钮事件
    showDeleteConfirm (record) {
      this.$confirm({
        title: '确定删除当前管理员?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.loading = true
          return delRole({
            adminRoleId: record.id
          }).then((res) => {
            this.$message.success(res.msg)
            this.handleInitList()
          }).catch((err) => this.requestFailed(err))
            .finally(() => {
              this.loading = false
            })
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    handleSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`
      })
    },
    requestFailed (err) {
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleCancel () {
      this.$refs.AddManagement.resetField()
    }
  }
}
</script>
<style>
.edit-setting {
  margin: 0 10px;
}
.describe-textarea {
  resize: none;
}
.ant-card-head {
  position: relative;
}
.addPersetting {
  position: absolute;
  top: 11px;
  right: 30px;
}
</style>
